// TODO: Figure out why this does nothing
export const Divider = {
  defaultProps: {
    borderColor: "rgba(0, 124, 253, 0.15)",
  },
};
